import {SelectedDocs} from '../../modules'

export const SelectedDocsPage = () => {
  return <SelectedDocs />
}
